/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAlertIntervalType;
(function (ApiAlertIntervalType) {
    ApiAlertIntervalType["ALERT_PERIOD_TYPE_ASAP"] = "AlertPeriodTypeASAP";
    ApiAlertIntervalType["ALERT_PERIOD_TYPE_HOURLY"] = "AlertPeriodTypeHourly";
    ApiAlertIntervalType["ALERT_PERIOD_TYPE_DAILY"] = "AlertPeriodTypeDaily";
    ApiAlertIntervalType["ALERT_PERIOD_TYPE_WEEKLY"] = "AlertPeriodTypeWeekly";
    ApiAlertIntervalType["ALERT_PERIOD_TYPE_MONTHLY"] = "AlertPeriodTypeMonthly";
})(ApiAlertIntervalType || (ApiAlertIntervalType = {}));
export function ApiAlertIntervalTypeFromJSON(json) {
    return ApiAlertIntervalTypeFromJSONTyped(json, false);
}
export function ApiAlertIntervalTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAlertIntervalTypeToJSON(value) {
    return value;
}
